/* eslint-disable class-methods-use-this */

import { PagedResultDto } from 'services/dto';
import http from '../httpService';
import { CreateUnavailability, PagedUnavailability, Unavailability } from './dto/unavailability';
import { ICalendarDateRange } from '@models';

class UnavailabilityService {
  public async create(request: CreateUnavailability) {
    const result = await http.post('api/services/app/Unavailability/Create', request);
    return result.data.result;
  }

  public async getAll(request: PagedUnavailability): Promise<PagedResultDto<Unavailability>> {
    const result = await http.get('api/services/app/Unavailability/GetAll', {
      params: request,
    });
    return result.data.result;
  }

  public async getAllCalendar(request: ICalendarDateRange | undefined): Promise<Unavailability[]> {
    const result = await http.get('api/services/app/Unavailability/GetAllCalendar', {
      params: request,
    });
    return result.data.result;
  }

  public async delete(id: string) {
    const result = await http.delete(`api/services/app/Unavailability/Delete?id=${id}`);
    return result.data.result;
  }
}

export default new UnavailabilityService();
